import { combineReducers } from 'redux'
import multiselect from './multiselect'

export default combineReducers({
  multiselect,
})
